import {parseQueryParams} from '@wix/panda-js-utils'
import mapStyle from './map-style'
import './google-map.scss'

const GREY_MAP_STYLE = 'greyMap'

function initMap() {
  const urlParams = parseQueryParams(location.href)
  const position = {lat: Number(urlParams.lat || 0), lng: Number(urlParams.lng || 0)}
  const map = new google.maps.Map(document.getElementById('root')!, {
    zoom: 14,
    scrollwheel: false,
    center: position,
    draggable: true,
  })
  const styledMapType = new google.maps.StyledMapType(mapStyle)

  map.mapTypes.set(GREY_MAP_STYLE, styledMapType)
  map.setMapTypeId(GREY_MAP_STYLE)

  new google.maps.Marker({
    map,
    position,
  })

  document.addEventListener('mousedown', () => {
    const anchor = document.querySelector('a[href$="mapclient=apiv3"]') as HTMLAnchorElement
    if (anchor) {
      anchor.href = `https://www.google.com/maps/search/?api=1&query=${position.lat},${position.lng}`
    }
  })
}

;(window as any).initMap = initMap
